module.exports = __webpack_public_path__ + "img/icons/question-mark-1cdc6765fb597494069ed4e5b6b66036.svg";